import type {
  CreateCustomerInput,
  CreateProductInput,
  CreateUserInput,
  CreateVehicleInput,
  CreateWarehouseInput,
  Customer,
  Product,
  ProductCategory,
  UpdateCustomerInput,
  UpdateProductInput,
  UpdateUserInput,
  UpdateVehicleInput,
  UpdateWarehouseInput,
  User,
  Vehicle,
  Warehouse,
} from '@fdt/shared';
import { api } from '../api/client';
import { resource } from '../api/resource';

export const productsApi = resource<Product, CreateProductInput, UpdateProductInput>('/products');
export const customersApi = resource<Customer, CreateCustomerInput, UpdateCustomerInput>(
  '/customers',
);
export const usersApi = resource<User, CreateUserInput, UpdateUserInput>('/users');
export const warehousesApi = resource<Warehouse, CreateWarehouseInput, UpdateWarehouseInput>(
  '/warehouses',
);
export const vehiclesApi = resource<Vehicle, CreateVehicleInput, UpdateVehicleInput>('/vehicles');

/** Categories are unpaginated: there are few and the product form needs them all. */
export async function fetchCategories(): Promise<ProductCategory[]> {
  const { data } = await api.get<ProductCategory[]>('/product-categories');
  return data;
}

/** Sets a staff password. Separate from `update` because it revokes sessions. */
export async function setUserPassword(id: string, password: string): Promise<void> {
  await api.put(`/users/${id}/password`, { password });
}
